import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "defeat-miniboss",
    "stage": {
        "image": require("./image.png"),
        "imageOffset": {"x": -6, "y": -1},
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "width": 18,
            "height": 10,
        }),
        "text": "Defeat Francois",
        "conditions": [
            ...convertOldChapterScripting({
                "0:start": [
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 5},
                        "classKey": "oriana",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 4},
                        "classKey": "brigid",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 3},
                        "classKey": "callista",
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "callista",
                            "text": "Just beyond this outpost is the bridge to the fortress.",
                        },
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "callista",
                            "text": "It's all that stands between us and Saul.",
                            "expression": "stern"
                        },
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "???", "side": "right",
                            "text": "Hark? What have we here?",
                        }
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 0, "y": 5},
                        "classKey": "francois",
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "Francois", "side": "right",
                            "text": "Oriana! You've returned!",
                        }
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "oriana",
                            "text": "Aye, to put an end to this.",
                        },
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "Francois", "side": "right",
                            "text": "Alas. Poor last words.",
                            "expression": "smug"
                        }
                    },
                    {
                        "type": "StopDialogue",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 1, "y": 4},
                        "classKey": "#B",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 2, "y": 1},
                        "classKey": "#C",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 5, "y": 0},
                        "classKey": "#D",
                    },
                    {
                        "type": "DisplayDialogue",
                        "dialogue": {
                            "name": "brigid",
                            "text": "Charge!!",
                            "expression": "happy"
                        },
                    },
                    {
                        "type": "StopDialogue",
                    },
                ],
                "1:end": [
                    {
                        "type": "SpawnUnit",
                        "spawn": {
                            "key": "#1",
                            "position": {"x": 3, "y": -1},
                            "classKey": "archer",
                            "affiliation": "bad",
                        },
                    },
                    {
                        "type": "SpawnUnit",
                        "spawn": {
                            "key": "#2",
                            "position": {"x": -1, "y": 2},
                            "classKey": "berserker",
                            "affiliation": "bad",
                        },
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 3, "y": 0},
                        "classKey": "#1",
                    },
                    {
                        "type": "MoveUnit",
                        "position": {"x": 0, "y": 2},
                        "classKey": "#2",
                    }
                ],
            }, [
                {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                {"type": "FinishLocation", "locationKey": "4"},
                {"type": "UnlockLocations", "routeKeys": ["9", "10", "11"], "locationKeys": ["5"]},
                {"type": "UnlockLocations", "routeKeys": ["C1", "C2"], "locationKeys": ["C"]},
            ]),
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.units["francois"].isDead == true
                },
                "events": [
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/hero/chapters/upgrade-cleric")},
                    // {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
                    // {"type": "FinishLocation", "locationKey": "4"},
                    // {"type": "UnlockLocations", "routeKeys": ["9", "10", "11"], "locationKeys": ["5"]},
                    // {"type": "UnlockLocations", "routeKeys": ["C1", "C2"], "locationKeys": ["C"]},
                ]
            },
        ]
    },
}

// // https://serenesforest.net/wp-content/uploads/2017/02/21.png
// "defeat-miniboss": {
//     "music": "hero-alt",
//     "hasPreparation": false,
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/fork.png"),
//         "tiles": [
//             {"position": {"x": 0, "y": 0}, "passable": false},
//             {"position": {"x": 1, "y": 0}, "passable": false},
//             {"position": {"x": 1, "y": 1}, "passable": false},
//             {"position": {"x": 0, "y": 1}, "passable": false},
//             {"position": {"x": 4, "y": 0}, "passable": false},
//             {"position": {"x": 4, "y": 2}, "passable": false},
//             {"position": {"x": 4, "y": 3}, "passable": false},
//             {"position": {"x": 3, "y": 3}, "passable": false},
//             {"position": {"x": 2, "y": 3}, "passable": false},
//             {"position": {"x": 0, "y": 3}, "passable": false},
//             {"position": {"x": 2, "y": 4}, "passable": false},
//             {"position": {"x": 2, "y": 5}, "passable": false},
//             {"position": {"x": 2, "y": 7}, "passable": false},
//             // {"position": {x: 3, y: 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 4, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             {"position": {"x": 0, "y": 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             {"position": {"x": 2, "y": 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//         ]
//     },
//     "spawns": [
//         // mercenary
//         // archer
//         // cleric
//         {"position": {"x": 6, "y": 3}, "affiliation": "good"},
//         {"position": {"x": 6, "y": 4}, "affiliation": "good"},
//         {"position": {"x": 6, "y": 5}, "affiliation": "good"},
//         {"position": {"x": -1, "y": 5}, "affiliation": "bad", "classKey": "paladin", "key": "francois"},
//         {"position": {"x": -1, "y": 4}, "affiliation": "bad", "classKey": "berserker", "key": "#B"},
//         // {"position": {x: 0, y: 2}, "affiliation": "bad", "classKey": "rogue"},
//         {"position": {"x": -1, "y": 1}, "affiliation": "bad", "classKey": "berserker", "key": "#C"},
//         // {"position": {x: 5, y: 0}, "affiliation": "bad", "classKey": "archer"},
//         {"position": {"x": 5, "y": -1}, "affiliation": "bad", "classKey": "berserker", "key": "#D"},
//     ],
//     "events": {
//         "0:start": [
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 3},
//                 "classKey": "oriana",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 4},
//                 "classKey": "brigid",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 5},
//                 "classKey": "callista",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "callista",
//                     "text": "Just beyond this outpost is the bridge to the fortress.",
//                 },
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "callista",
//                     "text": "It's all that stands between us and Saul.",
//                 },
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "???", "side": "right",
//                     "text": "Hark? What have we here?",
//                 }
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 5},
//                 "classKey": "francois",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Francois", "side": "right",
//                     "text": "Oriana! You've returned!",
//                 }
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "oriana",
//                     "text": "Aye, to put an end to this.",
//                 },
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "Francois", "side": "right",
//                     "text": "Alas. Poor last words.",
//                 }
//             },
//             {
//                 "type": "StopDialogue",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 1, "y": 4},
//                 "classKey": "#B",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 1},
//                 "classKey": "#C",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 5, "y": 0},
//                 "classKey": "#D",
//             },
//             {
//                 "type": "DisplayDialogue",
//                 "dialogue": {
//                     "name": "brigid",
//                     "text": "Charge!!",
//                 },
//             },
//             {
//                 "type": "StopDialogue",
//             },
//         ],
//         "1:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 3, "y": -1},
//                     "classKey": "archer",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#2",
//                     "position": {"x": -1, "y": 2},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 3, "y": 0},
//                 "classKey": "#1",
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 0, "y": 2},
//                 "classKey": "#2",
//             }
//         ],
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "4"},
//         {"type": "UnlockLocations", "routeKeys": ["9", "10", "11"], "locationKeys": ["5"]},
//         {"type": "UnlockLocations", "routeKeys": ["C1", "C2"], "locationKeys": ["C"]},
//     ],
//     "nextUrl": "/games/hero/chapters/upgrade-cleric",
// },
